module.exports = __webpack_public_path__ + "static/media/IMG-20191219-WA0002.a6b72c77.jpg";